module.exports = __webpack_public_path__ + "frontend-assets/img/avatar-placeholder.16a6477b.png";